import { Cell, Column, Heading, TimePeriodValue } from "@edgetier/client-components";
import { differenceInSeconds } from "date-fns";
import { FunctionComponent, memo } from "react";
import { IInteraction } from "@edgetier/watchtower-types";
import { IProps } from "./interactions-table-current-queue-time-column.types";
import "./interactions-table-current-queue-time-column.scss";

/**
 * Show the queue time of all queuing and completed interactions. This isn't an interaction metric as that is not
 * officially recorded until the interaction finished.
 * @returns Queue time column.
 */
const InteractionsTableCurrentQueueTimeColumn: FunctionComponent<IProps> = () => {
    return (
        <Column>
            <Heading>Queue Time</Heading>
            <Cell<IInteraction>>
                {({ enterQueueDateTime, exitQueueDateTime }) => (
                    <TimePeriodValue
                        seconds={
                            enterQueueDateTime instanceof Date
                                ? differenceInSeconds(exitQueueDateTime ?? new Date(), enterQueueDateTime)
                                : null
                        }
                    />
                )}
            </Cell>
        </Column>
    );
};

export default memo(InteractionsTableCurrentQueueTimeColumn);
